import { Navigate } from "react-router-dom";

/** Learning now lives in Simulation → Learn (Intern Academy). */
export default function TrainRedirect() {
  return <Navigate to="/simulation?view=learn" replace />;
}
